import moment from 'moment'

class DelayCertificateHelper {
  static formattedDate(date) {
    if (!date) {
      return ""
    }
    const mtime = moment.tz(date, 'Asia/Tokyo')
    return mtime.format("YYYY年M月D日") + '（' + ['日', '月', '火', '水', '木', '金', '土'][mtime.weekday()] + '）'
  }

  static delayTimeZoneHuman(timeZone) {
    switch(timeZone){
      case 1:
        return '始発 - 10:00'
      case 2:
        return '10:00 - 17:00'
      case 3:
        return '17:00 - 終電'
      default:
        return ''
    }
  }

  static delayTimeHuman(delayTime) {
    if(delayTime < 60) {
      return `${delayTime}分`
    } else {
      return '1時間以上'
    }
  }
}

export default DelayCertificateHelper